import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import JournalViewer from '../../../../DaEditorWrapper/Viewer/Journal';
import JournalViewerV3 from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/Journal';
import TextRenderer from '../../../../TextRenderer';
import { MatureDeviationContext } from '../../../../Context/MatureDeviationContext';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
const TextContent = ({ textContent, className, deviationId, disableStylesForLegacy })=>{
    const { t } = useTranslation();
    const { showBlocked } = useContext(MatureDeviationContext);
    return showBlocked ? /*#__PURE__*/ React.createElement("div", {
        className: className
    }, t('deviation.details.hiddenContent')) : /*#__PURE__*/ React.createElement(TextRenderer, {
        className: className,
        textContent: textContent,
        reactViewer: JournalViewer,
        tipTapViewer: JournalViewerV3,
        withSafetyCheckModal: true,
        cookieType: MeasuredCookieType.EDITOR_JOURNAL,
        defaultSize: {
            desktop: {
                width: 780,
                height: 40
            },
            mobile: {
                width: 380,
                height: 80
            }
        },
        viewerKey: deviationId,
        legacyTheme: "journal",
        disableStylesForLegacy: disableStylesForLegacy
    });
};
TextContent.displayName = 'TextContent';
export default TextContent;

//# sourceMappingURL=TextContent.js.map